import {useState} from 'react';
import {CodeRecipe} from '../CodeRecipe';
import './Template.scss';
export const Template = () => {
	type TitleFileLocation = {
		title: string;
		fileLocation: string;
	};
	const titles: TitleFileLocation[] = [
		{
			title: 'SB RestController',
			fileLocation: `${process.env.PUBLIC_URL}/static_templates/sb_restcontroller.java`,
		},
		{
			title: 'SB Repository',
			fileLocation: `${process.env.PUBLIC_URL}/static_templates/sb_repository.java`,
		},
		{
			title: 'JPA Entity',
			fileLocation: `${process.env.PUBLIC_URL}/static_templates/sb_entity.java`,
		},
		{
			title: 'DTO',
			fileLocation: `${process.env.PUBLIC_URL}/static_templates/sb_dto.java`,
		},
		{
			title: 'SB Service',
			fileLocation: `${process.env.PUBLIC_URL}/static_templates/sb_service.java`,
		},
	];
	const [currentTitleFileLocation, setCurrentTitleFileLocation] =
		useState<TitleFileLocation>(titles[0]);
	const btns = titles.map((tit) => {
		let cls = 'buttonSelectable';
		if (tit.title === currentTitleFileLocation.title)
			cls += ' 	buttonSelectable--selected';
		return (
			<div
				key={tit.title}
				className={cls}
				onClick={() => setCurrentTitleFileLocation(tit)}
			>
				{tit.title}
			</div>
		);
	});
	return (
		<>
			<div key='template_top_panel' className='panel'>
				<div
					className='template_top_panel_header'
					key='template_top_panel_header'
				>
					Live Templates for IntelliJ
					<p>
						<a href='https://www.youtube.com/watch?v=KvxmyHidnlU&ab_channel=MikeM%C3%B8llerNielsen'>
							(Watch on YT)
						</a>
					</p>
				</div>
				<div key='button_template' className='template_buttons'>
					{btns}
				</div>
			</div>
			<CodeRecipe
				title={currentTitleFileLocation.title}
				fileLocation={currentTitleFileLocation.fileLocation}
			/>
		</>
	);
};
